import baseAxiosAuthServicos from './config/baseAxiosAuthServicos';
import { getCPF, getDateStringBR, getIniciasNome, getValueNumber } from '../helpers/util';

async function getInfo() {
    return baseAxiosAuthServicos.get('/v1/perfil')
        .then(({ data }) => {
            const {
                nome,
                nomeSocial,
                cpf,
                tipoDocumento,
                numeroDocumento,
                matricula,
                dataNascimento,
                estadoCivil,
                nomePai,
                nomeMae,
                email,
                dddResidencial,
                telefoneResidencial,
                dddComercial,
                telefoneComercial,
                codigoTipoEndereco,
                cep,
                cidade,
                tipoEndereco,
                uf,
                tituloEndereco,
                descricaoLogradouro,
                logradouro,
                numero,
                complemento,
                bairro,
            } = data;

            const informacoes = {
                cpf: getCPF(cpf),
                tipoDocumento: tipoDocumento,
                numeroDocumento: numeroDocumento,
                nascimento: getDateStringBR(dataNascimento),
                matricula: matricula,
                nome: nome,
                nomeSocial: nomeSocial ?? '',
                nomeIniciais: getIniciasNome(nome),

                estadoCivil: estadoCivil,
                nomePai: nomePai,
                nomeMae: nomeMae,

                dddAdicional: dddResidencial === "0" ? "" : dddResidencial,
                telefoneAdicional: telefoneResidencial === "0" ? "" : telefoneResidencial,
                dddPrincipal: dddComercial,
                telefonePrincipal: telefoneComercial,
                email: email,

                codigoTipoEndereco: codigoTipoEndereco,
                tipoEndereco: tipoEndereco,
                cep: cep,
                uf: uf,
                cidade: cidade,
                bairro: bairro,
                tipoLogradouro: descricaoLogradouro,
                tituloEndereco: tituloEndereco,
                logradouro: logradouro,
                logradouroCompleto: `${descricaoLogradouro ?? ''} ${tituloEndereco ?? ''} ${logradouro ?? ''}`,
                numero: numero,
                complemento: complemento,
            };
            return informacoes;
        });
}

async function putAtualizarInfo({
    nomeSocial,
    nomePai,
    nomeMae,
    dddAdicional,
    telefoneAdicional,
    dddPrincipal,
    telefonePrincipal,
    codigoTipoEndereco,
    cep,
    numero,
    complemento,
}) {
    const payload = {
        nomeSocial: nomeSocial === '' ? null : nomeSocial,
        nomePai: nomePai === '' ? null : nomePai,
        nomeMae: nomeMae === '' ? null : nomeMae,
        dddAdicional: getValueNumber(dddAdicional),
        telefoneAdicional: getValueNumber(telefoneAdicional),
        dddPrincipal: getValueNumber(dddPrincipal),
        telefonePrincipal: getValueNumber(telefonePrincipal),
        tipoEndereco: getValueNumber(codigoTipoEndereco),
        cep: getValueNumber(cep),
        numero: getValueNumber(numero),
        complemento
    };

    return baseAxiosAuthServicos.put('/v1/perfil', payload);
}

export {
    getInfo,
    putAtualizarInfo
};